import type React from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

import type { DropdownOption } from '..';

export type DropdownOptionWithRef<T extends string = string> =
  DropdownOption<T> & {
    ref?: React.RefObject<HTMLDivElement> | null;
  };

export interface DropdownContextType<T extends string = string> {
  collection: DropdownOptionWithRef<T>[];
  setOptions: Dispatch<SetStateAction<DropdownOption<T>[]>>;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  selected: DropdownOptionWithRef<T>[];
  onSelect: (item: T) => void;
  displaySelectedOptions: boolean;
  multiselect: boolean;
  isSelected: (item: T) => boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  maxSelectedOptions?: number;
  onLoadMore?: () => Promise<void>;
  loadMoreDistance: number;
  noOptionsText?: string;
  loading: boolean;
  limitDisplayRows?: boolean;
}

// Using `null as unknown as DropdownContextType` to identify whether the context is initialized
// It prevents hard to identify problems when the context is not used within the provider
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DropdownContext = createContext<DropdownContextType<any> | null>(
  null,
);

DropdownContext.displayName = 'DropdownContext';
